/* eslint-disable react/jsx-props-no-spreading */
import { TextField as InMarKitTextField, TextFieldProps as InMarkitTextFieldProps } from '@mui/material';
import { isNil } from 'lodash-es';
import React from 'react';
import { ControllerRenderProps, FieldValues, useController, useFormContext } from 'react-hook-form';

export type TextFieldProps = {
  normalizeOutput?: Function;
  normalizeInput?: Function;
  name: string;
  label: string;
  rules?: any;
  inputProps?: any;
  onMouseOut?: (e: any, field: ControllerRenderProps<FieldValues, string>) => void;
} & Omit<InMarkitTextFieldProps, 'onMouseOut'>;

function TextField({
  name,
  normalizeOutput = (event) => event,
  normalizeInput = (input) => input,
  rules,
  inputProps,
  label,
  onMouseOut,
  ...rest
}: TextFieldProps) {
  const { control, register } = useFormContext();
  const { field, fieldState } = useController({ control, name });
  const value = normalizeInput(field.value);
  return (
    <InMarKitTextField
      {...register(name, rules)}
      variant="standard"
      size="small"
      value={isNil(value) ? '' : value}
      onChange={(event) => field.onChange(normalizeOutput(event))}
      onBlur={field.onBlur}
      onMouseOut={(e) => {
        if (onMouseOut) {
          onMouseOut(e, field);
        }
      }}
      inputRef={field.ref}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      // Autocomplete with 'name' if the field name has the word 'name' in it.
      autoComplete={rest.autoComplete || name.toLowerCase().indexOf('name') >= 0 ? 'name' : 'off'}
      inputProps={{
        ...inputProps,
        style: { ...inputProps?.style, resize: rest.multiline && 'vertical' },
      }}
      placeholder={`Add ${label || 'Value'}`}
      label={label}
      {...rest}
    />
  );
}

export default TextField;
